import assert from 'minimalistic-assert';
import BipPath from 'bip32-path';
import * as util from './util.js';
import { ModelIdSymbol } from '../constants.js';
import { createIsInstance, omitUndefined } from '../utils.js';
import { isKeyIdentifierLike } from './util.js';
export default class Address {
    address;
    meta;
    constructor(address, meta) {
        this.address = address;
        this.meta = meta || Object.create(null);
    }
    static get [ModelIdSymbol]() {
        return 'Address';
    }
    static _isInstance = createIsInstance(Address);
    static [Symbol.hasInstance](x) {
        return this._isInstance(x);
    }
    static isInstance = Address[Symbol.hasInstance];
    static create(address, meta) {
        return Object.freeze(new Address(address, meta));
    }
    static fromJSON(json) {
        const data = typeof json === 'string' ? JSON.parse(json) : json;
        if (data.meta) {
            return Address.create(data.address, data.meta);
        }
        if (data.path !== undefined) {
            assert(typeof data.path === 'string', 'path must be a string');
            return Address.create(data.address, { path: data.path });
        }
        return Address.create(data.address);
    }
    get pathArray() {
        return BipPath.fromString(this.meta.path || 'm/0/0').toPathArray();
    }
    toJSON() {
        return {
            address: this.address,
            meta: this.meta,
        };
    }
    toRedactedJSON() {
        const redactedMeta = {
            path: this.meta.path,
            purpose: this.meta.purpose,
        };
        if (typeof this.meta.walletAccount === 'string') {
            redactedMeta.walletAccount = this.meta.walletAccount;
        }
        if (isKeyIdentifierLike(this.meta.keyIdentifier)) {
            const { derivationAlgorithm, keyType, derivationPath, assetName } = this.meta.keyIdentifier;
            redactedMeta.keyIdentifier = omitUndefined({
                derivationAlgorithm,
                keyType,
                derivationPath,
                assetName,
            });
        }
        return {
            address: this.address,
            meta: omitUndefined(redactedMeta),
        };
    }
    toString() {
        return this.address;
    }
    get [Symbol.toStringTag]() {
        return this.address;
    }
    static isAddress(address) {
        if (address instanceof Address)
            return true;
        if (typeof address !== 'object')
            return false;
        if (address === null)
            return false;
        const ownKeys = Object.keys(new Address(''));
        const candidateKeys = Object.keys(address);
        return (candidateKeys.length === ownKeys.length && candidateKeys.every((key) => ownKeys.includes(key)));
    }
    static util = util;
}
